// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df653486","533":"0f87e53b"}[chunkId] + ".chunk.js";
};